var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorticongrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.135,
    height: 15.511,
    viewBox: "0 0 22.135 15.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31733",
    "data-name": "Rectangle 31733",
    width: 22.135,
    height: 15.511,
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sort_icon_grey",
    "data-name": "Sort icon grey",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12782",
    "data-name": "Group 12782",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38860",
    "data-name": "Path 38860",
    d: "M1.1,5.5,5.385,1.484,9.584,5.5",
    transform: "translate(-0.048 0)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y2: 12.543,
    transform: "translate(5.338 1.484)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38861",
    "data-name": "Path 38861",
    d: "M21.652,10.011l-4.285,4.016-4.2-4.016",
    transform: "translate(-0.569 0)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y1: 12.543,
    transform: "translate(16.797 1.484)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorticongrey);
export default __webpack_public_path__ + "static/media/Sort icon grey.1f77440d9c3e1126283a58870fe73564.svg";
export { ForwardRef as ReactComponent };